export default __webpack_public_path__ + "static/media/Kings_Cove_LE.63c29188.jpg";